import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap, finalize, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ILogin } from 'src/app/@types/ILogin';
import { JwtHelperService } from '@auth0/angular-jwt';
import { jwtDecode } from 'jwt-decode';

const AUTH_ENDPOINT = `${environment.auth}`;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public readonly ACCESS_TOKEN_KEY = '@PortalProjo:access_token';
  private readonly REFRESH_TOKEN_KEY = '@PortalProjo:refresh_token';

  constructor(private _http: HttpClient, private router: Router) {}

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  isFirstAccess(): boolean {
    const jwtHelper = new JwtHelperService();

    const token: any = jwtHelper.decodeToken(this.getToken()!) as any;

    const { user_first_access } = token;

    return user_first_access;
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.ACCESS_TOKEN_KEY);
  }

  signIn(login: ILogin)  {
    return this._http.post(AUTH_ENDPOINT + '/security/login', login, { responseType: 'text' as const  })
      .pipe(
          tap(response => {
              const accessToken: string = response as unknown as string;
              sessionStorage.setItem("usuarioLogin", login.nome);
              this.initializeSession(accessToken);
          }),
          map(response => response as unknown as string)
      );
  }

  getVersion(): Observable<string> {
    return this._http.get<string>(AUTH_ENDPOINT + '/security/login/version');
  }


  obterUsuarioLogado(): string | null {
     return sessionStorage.getItem("usuarioLogin");
  }

  setUsuario(token: string){
    const decodedToken: any = jwtDecode(token);
    sessionStorage.setItem("usuarioLogin", decodedToken.usuario);
  }

  obterGrupoLogado(): string | null {
    return sessionStorage.getItem("grupo");
  }

  obterAcessoLogado(): boolean {
    return sessionStorage.getItem("acesso") == "true";
  }

  initializeSession(accessToken: any) {
    sessionStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
    const decodeToken:any = jwtDecode(accessToken); 
    sessionStorage.setItem("acesso", decodeToken.acesso);
    sessionStorage.setItem("grupo", decodeToken.sub);
  }

  destroySession = (): void => {
    sessionStorage.removeItem(this.ACCESS_TOKEN_KEY);
    sessionStorage.removeItem('usuarioLogin');
    sessionStorage.removeItem('acesso');
    sessionStorage.removeItem('grupo');
  }

  logout(): Observable<void> {
    return this._http.post<void>(`${environment.backendUrl}/logout`, {})
      .pipe(finalize(() => {
        this.destroySession();
        this.router.navigate(['/login']);
      }));
  }

}
